/* 
 * TransitionContent.js
 * Created on 24-aug-2017
 * @author Swen Meeuwes / Olivier van der Pool for &ranj
 */

import { isArray, isNull } from "../../util/TypeUtil";
import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";

export default class TransitionContent extends Content {
    constructor(languagePack, contentID, label) {
        super(TransitionContent.NAME, TransitionContent.TYPE, label, languagePack, contentID);

        this._localLanguagePack = languagePack;
        this._localContentID = contentID;
        this._localLabel = label;
        this._mutations = [];
    }

    remove() {

        super.remove();
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_TRANSITION, this.getLanguagePack());
        clone.setContentID(this.getContentID());

        for (let i = 0; i <= this.getMutations().length; i++) {
            clone.getMutations().push(this.getMutations()[i].clone());
        }

        return clone;
    }

    getValueForProperty(property) {
        return this.getLanguagePackText(property);
    }

    setValueForProperty(property, value) {
        if (this.getValueForProperty(property) !== value) {
            this.setLanguagePackText(property, value);
        }
    }

    getMutations() {
        return this._mutations;
    }

    setMutations(mutations) {
        this._mutations = mutations;
    }

    convertToObject() {
        const object = super.convertToObject();
        object._mutations = [];
        for (let i = 0; i < this._mutations.length; i++) {
            object._mutations[i] = this._mutations[i].convertToObject();
        }

        return object;
    }

    setPropertiesFromObject(object) {
        if (!isNull(object.mutations) && isArray(object.mutations)) {
            for (let i = 0; i < object.mutations.length; i++) {
                this._mutations[i] = ContentFactory.getContentFromObject(object.mutations[i], this.getLanguagePack());
            }
            delete object.mutations;
        }

        super.setPropertiesFromObject(object);
    }

    getDescriptionLabel() {
        return "<TRANSITION>";
    }
}


TransitionContent.TYPE = ContentTypes.TYPE_TRANSITION;
TransitionContent.NAME = "Transition";
